// authService.js
import { jwtDecode } from "jwt-decode";

export const authService = {
  decodeToken: (token) => {
    const decodedToken = jwtDecode(token);
    const roleClaim = Object.entries(decodedToken).find(([key]) => 
      key.includes('role') || key.endsWith('/role')
    );
    
    return {
      id: decodedToken.sub,
      username: decodedToken.name,
      role: roleClaim ? roleClaim[1] : null
    };
  }
};